import "./event-target";
import "./abort-signal";
import { ready as resizeObserverReady } from "./resize-observer";

export const ready: Promise<void> = resizeObserverReady;
